import { PriceType } from '../classes/price-type';
import { CartSeat } from '../classes/seat';
import { IAppState } from '../reducers';
import { IAppSettingsModel } from '../reducers/fetch-settings-reducer';
import { ItemType } from '../classes/item-type';


export namespace CartHelpers {

    export function maxSeatsInCart(priceTypeId: number, cartSeats: CartSeat[], priceTypes: PriceType[]): boolean {
        const seatsInCart = cartSeats.filter(s => s.selectedPricing.priceTypeId == priceTypeId).length;
        const priceMaxQuantity = getPriceMaxQuantity(priceTypeId, priceTypes);
        return seatsInCart >= priceMaxQuantity;
    }

    export function checkCartForMinQuantities(cartSeats: CartSeat[], priceTypes: PriceType[]): boolean {
        return priceTypes.filter(pt => {
            var seatsInCart = cartSeats.filter(s => s.selectedPricing.priceTypeId == pt.priceTypeId).length;
            let priceMinQuantity = getPriceMinQuantity(pt.priceTypeId, priceTypes);
            return seatsInCart < priceMinQuantity;
        }).length > 0
    }

    export function checkPriceTypeForMinQuantities(priceTypeId: number, cartSeats: CartSeat[], priceTypes: PriceType[]): boolean {
        const seatsInCart = cartSeats.filter(s => s.selectedPricing.priceTypeId == priceTypeId).length;
        const priceMinQuantity = getPriceMinQuantity(priceTypeId, priceTypes);
        return seatsInCart >= priceMinQuantity;
    }

    function getPriceMaxQuantity(priceTypeId: number, priceTypes: PriceType[]) {
        const priceTypeMatches = priceTypes.filter(pt => pt.priceTypeId == +priceTypeId);
        if (priceTypeMatches.length > 0) {
            return priceTypeMatches[0].clientMaxQuantity;
        } else {
            return 0;
        }
    }

    function getPriceMinQuantity(priceTypeId: number, priceTypes: PriceType[]) {
        const priceTypeMatches = priceTypes.filter(pt => pt.priceTypeId == +priceTypeId);
        if (priceTypeMatches.length > 0) {
            return priceTypeMatches[0].clientMinQuantity;
        } else {
            return 0;
        }
    }


    //used for flex or super package
    export function isSetQuantityPackage(settings: IAppSettingsModel) {
        return settings.itemType == ItemType.Flex || settings.itemType == ItemType.Super;
    }

    export function isFlexCartFull(state: IAppState) {
        const seats = state.cartModel.seats;
        const priceTypes = state.priceTypesModel.priceTypes;

        return priceTypes.every(p => seats.filter(s => s.selectedPricing.priceTypeId === p.priceTypeId).length === p.selectedQuantity);
    }

    export function checkForcedMultipleReserve(forcePatronsReserveInMultiples: number, priceTypes: Array<PriceType>): number {
        if (forcePatronsReserveInMultiples > 0
            && priceTypes.reduce((a, b) => a + b.selectedQuantity, 0) % forcePatronsReserveInMultiples !== 0)
            return forcePatronsReserveInMultiples;
        else {
            var returnVal = 0;

            priceTypes.some(pt => {
                if (pt.selectedQuantity > 0 && pt.forceReserveInMultiplesOf > 0 && (pt.selectedQuantity % pt.forceReserveInMultiplesOf !== 0)) {
                    returnVal = pt.forceReserveInMultiplesOf;
                    return true;
                }

            })
            return returnVal;
        }
    }

}